import { fmtUSD } from "../../lib/api";
import { fmtMult } from "./calc";

export function Result({ amount, entry, testid }) {
  const projected = amount * (entry?.multiple || 1);
  const gain = projected - amount;
  return (
    <div className="gapped-enclosure p-6 sm:p-8" data-testid={`${testid}-result`}>
      <span className="t-label">Projected value</span>
      <div className="fig mt-2 text-[#C69A4E]" style={{ fontSize: 44, lineHeight: 1 }} data-testid={`${testid}-projected`}>
        {fmtUSD(projected)}
      </div>
      <div className="mt-6 grid grid-cols-2 gap-y-4 gap-x-6">
        <div>
          <span className="t-label">Multiple</span>
          <div className="fig t-body text-bone mt-1" data-testid={`${testid}-moic`}>{fmtMult(entry?.multiple || 1)}</div>
        </div>
        <div>
          <span className="t-label">Illustrative gain</span>
          <div className="fig t-body text-bone mt-1">{fmtUSD(gain)}</div>
        </div>
      </div>
      {entry?.detail && <p className="t-cap text-muted-s mt-6">{entry.detail}</p>}
    </div>
  );
}
